import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-twitter';
export var ID = 'icon-twitter';
/* eslint-disable max-len */

export var SVGTwitter = function SVGTwitter() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 14"
  }, React.createElement("defs", null, React.createElement("polygon", {
    id: "path-1-twitter",
    points: "6.4e-06 0 16 0 16 13.0008192 6.4e-06 13.0008192"
  })), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-334.000000, -464.000000)"
  }, React.createElement("g", {
    transform: "translate(334.000000, 463.000000)"
  }, React.createElement("g", {
    transform: "translate(0.000000, 1.333333)"
  }, React.createElement("mask", {
    id: "mask-2-twitter",
    fill: "white"
  }, React.createElement("use", {
    xlinkHref: "#path-1-twitter"
  })), React.createElement("g", null), React.createElement("path", {
    d: "M5.0316864,13.0008192 C11.0694464,13.0008192 14.3717824,7.9985792 14.3717824,3.6606592 C14.3717824,3.5185792 14.3717824,3.3771392 14.3622464,3.2363392 C15.0046784,2.7716352 15.5592384,2.1962752 16.0000064,1.5371392 C15.4009024,1.8026112 14.7653184,1.9767552 14.1145664,2.0536192 C14.7998144,1.6433792 15.3127744,0.9981312 15.5577664,0.2379392 C14.9133504,0.6203392 14.2084544,0.8897792 13.4732224,1.0347392 C12.2300864,-0.2871808 10.1505984,-0.3509888 8.8286784,0.8922112 C7.9761344,1.6939392 7.6144064,2.8886912 7.8790464,4.0286592 C5.2396224,3.8963712 2.7804864,2.6496512 1.1136064,0.5988992 C0.2423104,2.0988672 0.6873664,4.0177152 2.1299264,4.9809792 C1.6074944,4.9654912 1.0965184,4.8245632 0.6400064,4.5700992 L0.6400064,4.6116992 C0.6404544,6.1743232 1.7418944,7.5201792 3.2736064,7.8296192 C2.7903424,7.9614592 2.2832704,7.9807232 1.7913664,7.8859392 C2.2213824,9.2232192 3.4538304,10.1392512 4.8582464,10.1656192 C3.6958144,11.0792192 2.2598464,11.5751552 0.7814464,11.5736192 C0.5202624,11.5731072 0.2593344,11.5572992 6.4e-06,11.5262592 C1.5011904,12.4896512 3.2479424,13.0006272 5.0316864,12.9982592",
    fill: "#1DA1F2",
    mask: "url(#mask-2-twitter)"
  }))))));
};
/* eslint-disable max-len */

var Twitter = function Twitter(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGTwitter
  });
};

Twitter.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Twitter;